import React from "react";
import { connect } from "react-redux";
import Navbar from "./Navbar";
import "aos/dist/aos.css"; // You can also use <link> for styles
import Aos from "aos";
import Footer from "../component/footer";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { IoMdQuote } from "react-icons/io";
import { AiFillStar } from "react-icons/ai";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    paritialVisibilityGutter: 60,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    paritialVisibilityGutter: 50,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30,
  },
};
Aos.init();

function Home(props) {
  return (
    <>
      <div className="mainNav" >
        <Navbar current='Home'  />
        <div data-aos="zoom-in" data-aos-duration="800" className="front_side">
          <h1 className="front_heading">
            Anything from <br></br> anywhere in your city
          </h1>

          <div className="front_buttons">
            <img src={require("../assets/1.png")} className="play_button"></img>
            <img src={require("../assets/2.png")} className="play_button"></img>

            <img src={require("../assets/3.png")} className="play_button"></img>
          </div>
        </div>
      </div>
      <video autoPlay id="video" loop muted>
        <source src={require("../assets/video.mp4")} type="video/mp4" />
      </video>

      <div className="backVideo"></div>

      <div className="box" >
        <h1
          data-aos="zoom-in-up"
          data-aos-once="true"
          data-aos-duration="800"
          className="front_heading1"
        >
          What is HAC?
        </h1>

        <p
          data-aos="zoom-in-up"
          data-aos-duration="800"
          data-aos-once="true"
          class="text-center"
        >
          HAC is one of the largest delivery platform in the region. HAC's
          unique on-demand experience earned it the highest user ratings amongst
          all the other large delivery platforms both in Apple’s App Store and
          Google's Play store. In 2018, HAC reported GMV exceeding 1 billion
          SR and more than 6 million registered users. HAC provides a true
          order anything from anywhere experience, only possible by our huge
          fleet of registered on-demand couriers anything from anywhere with a
          huge fleet of registered couriers.
        </p>

        <button className="currentNavButt">Know More About Us</button>

        <div data-aos="zoom-in" data-aos-duration="800" className="aboutDivs">
          <div>
            <img
              src={require("../assets/home.png")}
              className="aboutImages"
            ></img>
            <h1 className="front_heading2">1000K</h1>
            <p>Stores</p>
          </div>

          <div>
            <img
              src={require("../assets/people.png")}
              className="aboutImages"
            ></img>
            <h1 className="front_heading2">12M+</h1>
            <p>People</p>
          </div>

          <div>
            <img
              src={require("../assets/shop.png")}
              className="aboutImages"
            ></img>
            <h1 className="front_heading2">7000K</h1>
            <p>Countries</p>
          </div>
        </div>
      </div>

      <div className="box2">
        <h1
          data-aos="zoom-in-up"
          data-aos-once="true"
          data-aos-duration="800"
          className="front_headingw"
        >
          Reach Millions of Customers
        </h1>

        <p
          data-aos="zoom-in-up"
          data-aos-duration="800"
          data-aos-once="true"
          class="text-center text-white fontS"
        >
          HAC for Business provides your business an access to a huge user
          base, whether you want to transform to on-demand eCommerce, or simply
          looking for an additional channel, HAC is always there to help!
        </p>

        <button className="currentNavButt1">Know More About Us</button>
      </div>

      <div className="backVideo1"></div>

      <div className="box">
        <h1
          data-aos="fade-left"
          // data-aos-once="true"
          data-aos-duration="800"
          className="front_heading4"
        >
          How We Do it?
        </h1>

        <p data-aos="fade-right" data-aos-duration="1200" class="textcenter1">
          By building an intuitive product that mimics and facilitates generic
          service fulfillment, so the simple answer was to provide users with
          three things.
        </p>

        <div data-aos="zoom-in" data-aos-duration="800" className="aboutDivs">
          <div>
            <img
              src={require("../assets/message.png")}
              className="aboutImages"
            ></img>
            <h1 className="front_heading5">Personalized Delivery Experience</h1>
            <p>
              Control your delivery experiences in real-time through an open
              chat with your courier
            </p>
          </div>

          <div>
            <img
              src={require("../assets/hand.png")}
              className="aboutImages"
            ></img>
            <h1 className="front_heading5">Flexible Bidding System</h1>
            <p>
              Service prices are determined beforehand through our bidding
              system, giving customers the freedom to choose from multiple
              service providers
            </p>
          </div>

          <div>
            <img
              src={require("../assets/location.png")}
              className="aboutImages"
            ></img>
            <h1 className="front_heading5">Integrated Map Solution</h1>
            <p>
              Pick anywhere on the map for your delivery order, and track your
              order in real-time
            </p>
          </div>
        </div>
      </div>

      <div className="box1">
        <h1
          data-aos="fade-left"
          // data-aos-once="true"
          data-aos-duration="800"
          className="front_heading4"
        >
          Our Journey
        </h1>
        <p
          data-aos="fade-right"
          data-aos-duration="1200"
          class="textcenter1 bottomBorder"
        >
          Start From one people Startup to internetionally team building.
        </p>

        <div className="boxVideo">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe
              class="embed-responsive-item"
              src="https://www.youtube.com/embed/PTeKSHn1aJA"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>

      <div className="box3">
        <h1
          // data-aos="zoom-in-up"
          // data-aos-once="true"
          // data-aos-duration="800"
          className="front_heading1"
        >
          User Testimonies
        </h1>
        <Carousel itemClass="image-item" responsive={responsive}>
          {[0, 1, 2, 3, 4, 56, 7, 8, 9, 110, 23].map((post, indx) => {
            return (
              <div
                data-aos="flip-up"
                data-aos-duration="1200"
                className="testinal"
                key={indx}
              >
                <div className="testimonalClass">
                  <IoMdQuote size={50} color="#969FA4" />
                  <p>
                    "HAC" a simple way to order anything you want from
                    thousands of places in your neighborhood shops, grocery,
                    stores, restaurants, and favorites delivered straight to
                    your door, and more. the best delivery apps to use. 👍
                  </p>
                  <br />
                  <br />
                  <br></br>
                  <hr></hr>
                  <p>Haider</p>
                  <div className="flex">
                    <AiFillStar color="#FAB84C" size={25} />
                    <AiFillStar color="#FAB84C" size={25} />
                    <AiFillStar color="#FAB84C" size={25} />
                    <AiFillStar color="#FAB84C" size={25} />
                    <AiFillStar color="#FAB84C" size={25} />
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>

      <Footer />
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    name: state.name,
  };
};

export default connect(mapStateToProps, null)(Home);
